/**
 * @description: 右侧嵌套列表组件
 * @author:
 */
<template>
  <div class="detail-min-table" :style="{ width: option.width || 'auto' }">
    <div class="row-head">
      <div v-for="item in option.head" :key="item.prop" class="item" :style="{ width: '100px', ...(item.style || {}) }">
        {{ item.label }}
      </div>
    </div>
    <template v-for="(center, index) in list">
      <div class="center-row" :key="center.id">
        <div v-for="item in option.head" :key="item.prop" class="item" :style="{ width: '100px', ...(item.style || {}) }">
          <template v-if="item.prop === 'index'">
            {{ index + 1 }}
          </template>
          <template v-if="item.prop === 'detailIcon'">
            <span class="child-btn" @click="childBtn(index)">{{ center.btn ? '关闭' : '展开' }}</span> <span class="child-num">{{ center.child.length }}</span>
          </template>
          <slot :name="`${item.prop}Slot`" v-if="item.slot" :item="center" />
          <template v-else-if="item.formatter && typeof item.formatter === 'function'">{{ item.formatter(center) }}</template>
          <template v-else-if="item.type && item.type === 'enclosure' && center[item.prop]">
            <div class="enclosure_text">
              <span v-if="center[item.prop][0].length" @click="showAndDown(center[item.prop][0])">查看</span
              ><span style="margin-left: 10px" v-if="center[item.prop][1].length" @click="fileList(center[item.prop][1])">下载</span>
            </div>
          </template>
          <template v-else>{{ center[item.prop] }}</template>
          <i v-if="item.decode && isEncryption" class="iconfont iconfuwuzhiliang-mingwen pointer-view" @click="$emit('decode')" />
        </div>
      </div>
      <!-- 子列表 -->
      <div v-show="center.btn" class="child-content" :key="index" :style="{ width: optionChild.width || 'auto'}">
        <div class="record-list" :style="{ width: '76px'}">处理记录</div>
        <div class="record-main">
          <div class="record-title">
            <div v-for="(title, indx) in optionChild.head" :key="indx" :style="{ width: '100px', ...(title.style || {}) }">{{title.label}}</div>
          </div>
          <div v-for="(item, index) in center.child" :key="index" class="record-title">
            <div v-for="(title, i) in optionChild.head" :key="i" :style="{ width: '100px', ...(title.style || {}) }">
              <template v-if="title.prop === 'enclosure'">
                <div class="enclosure_text" v-if="item[title.prop].length">
                  <span v-if="item[title.prop][0].length" @click="showAndDown(item[title.prop][0])">查看</span
                  ><span style="margin-left: 10px" v-if="item[title.prop][1].length" @click="fileList(item[title.prop][1])">下载</span>
                </div>
              </template>
              <span v-else>
                {{item[title.prop]}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-if="!value.length" class="none-date">{{ $lang('暂无数据') }}</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showFileDialog: false,
      fileData: [],
      list: []
    }
  },
  props: {
    option: Object,
    value: {
      type: Array,
      default: () => []
    },
    width: {
      type: String,
      default: 'auto'
    },
    height: {
      type: String,
      default: 'auto'
    },
    optionChild: Object,
    encryption: Boolean,
    expansionBtn: Boolean
  },
  computed: {
    isEncryption () {
      const { senderMobilePhone, receiverMobilePhone } = this.value[0]
      return this.encryption && (senderMobilePhone && senderMobilePhone.match(/\*/) || receiverMobilePhone && receiverMobilePhone.match(/\*/))
    }
  },
  watch: {
    'value': {
      handler (o) {
        this.list.length = 0
        this.list.push(...o)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 查看图片
    showAndDown (e) {
      this.$openImagePreview(e, 0, null, true)
    },
    closeDialog (e) {
      this.showFileDialog = e
      console.log(e)
    },
    fileList (file = []) {
      if (file.length === 1) {
        window.location.href = file
      }
      if (file.length > 1) {
        this.fileData = file
        this.showFileDialog = true
      }
    },
    // 操作
    operation (val) {
      this.$emit('operation', val)
    },
    childBtn(index) {
      const item = this.list[index]
      item.btn = !item.btn
      this.list.splice(index, 1, item)
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-min-table {
  min-width: 100%;
  overflow: auto;
  border: 1px solid;
  border-radius: 4px;
  @include border-color('lighter');
  .row-head {
    width: auto;
    display: flex;
    border: 0;
    font-weight: bold;

    .item {
      height: 20px;
      @include bg-color('pop-active');
    }
  }
}

.center-row {
  width: auto;
  display: flex;

  .item {
    border-bottom: 1px solid;
    @include border-color('lighter');

    .child-num {
      display: inline-block;
      width: auto;
      height: 16px;
      color: aliceblue;
      background-color: #4370f6;
      border-radius: 2px;
      padding: 0 4px;
    }

    .child-btn {
      cursor: pointer;
    }
  }

}

.child-content {
  width: 100%;
  display: flex;
  color: #4c4d57;
  background-color:#f5f7fa;

  .record-list {
    display: flex;
    align-items: center;
    padding: 10px;
    border-right: 1px solid;
    @include border-color('lighter');
  }
  .record-main {
    flex: 1 1;
  }
  .record-title {
    display: flex;
    min-height: 30px;
    padding: 10px;
    line-height: 16px;
    border-bottom: 1px solid;
    @include border-color('lighter');
  }
}
.item {
  flex-shrink: 0;
  flex-grow: 0;
  float: left;
  word-break: break-all;
  white-space: normal;
  font-size: 12px;
  line-height: 16px;
  padding: 10px;
  &:not(:first-child) {
    border-left: 1px solid;
    @include border-color('lighter');
  }
}
.enclosure_text {
    cursor: pointer;
    @include base-color('clr');
  }
.none-date {
  text-align: center;
  font-size: 12px;
  line-height: 60px;
  color: #909399;
  max-width: calc(100vw - 420px);
}
.head {
  line-height: 40px;
  height: 40px;
}
.center {
  overflow: hidden;
  .row {
    border: 1px solid;
    @include border-color('lighter');
  }
}
.detail-view {
  border-top: 1px solid;
  @include border-color('lighter');
}
</style>

